import MTenantPreview from './TenantPreviewPure.vue';

export { MTenantPreview };
export default MTenantPreview;
